<template>
  <div class="common-items-center" :style='{marginRight:right*1+"px"}'>
      <div class="title">{{title}}</div>
      <el-select  v-model="value"  multiple  collapse-tags  @change="selectVal"   :size="size" :placeholder="placeholder" :style='{width:width*1+"px",marginLeft:left+"px"}'>
        <el-option  
           v-for="item in options" 
           :key="item.indexNo"  
           :label="item.selectName"  
           :value="item.indexNo"
           >
        </el-option>
      </el-select>
  </div>
  </template>
  <script>
    export default {
      data:()=>({
        value:""
      }),
      props:{
        size:{
          type: String,
          default: "small",
        },
        keyVal:{
          type: String,
          default: "key",
        },
        
        title: {
         type: String,
         default: "哈哈",
        },
        width:{
          type: String,
          default: "200",
        },
        left:{
          type: String,
          default: "8",
        },
        right:{
          type: String,
          default: "15",
        },
        options:{
          type: Array,
          default:()=>([
            { indexNo: '4', selectName: '选项1'}, 
            { indexNo: '6', selectName: '选项2'}
          ])
        },
        paddButtom:{
         type: String,
         default: "10",
       },
        placeholder:{
          type: String,
          default: "请选择",
        }
      },
      methods:{
        //选取的值
        selectVal(ev){
          let parms = {
              key:this.keyVal,
              val:ev
          }
          this.$emit("getVal",parms)
        },

        //设置或者清空默认值
        setVal(e){
          //  e = ["1","57","58"]
           this.value = e 
        }
      }

    }
  </script>
  <style scoped lang="scss">
      .title{
        font-size: 14px;
        color: #606266;
        font-weight: 600;
        text-align: right;
      }
  </style>